module.exports = __webpack_public_path__ + "static/media/quote.6743ecc4.svg";